export const USUARIO_PERMISSAO_MASTER = 0;
export const USUARIO_PERMISSAO_ADMINISTRADOR = 1;
export const USUARIO_PERMISSAO_MOTORISTA = 2;
export const USUARIO_PERMISSAO_VENDEDOR = 3;
export const USUARIO_PERMISSAO_INDUSTRIA = 4;
export const USUARIO_PERMISSAO_SUPERVISOR = 5;

export const usuarioPermissaoOptions = [
  { label: 'Master', value: USUARIO_PERMISSAO_MASTER },
  { label: 'Administrador', value: USUARIO_PERMISSAO_ADMINISTRADOR },
  { label: 'Motorista', value: USUARIO_PERMISSAO_MOTORISTA },
  { label: 'Vendedor', value: USUARIO_PERMISSAO_VENDEDOR },
  { label: 'Indústria', value: USUARIO_PERMISSAO_INDUSTRIA },
  { label: 'Supervisor', value: USUARIO_PERMISSAO_SUPERVISOR }
]

export const getUsuarioPermissaoLabel = (permissao) => {
  const found = usuarioPermissaoOptions.find(({ value }) => value === permissao)
  return found ? found.label : '--';
}

export const ITEM_TIPO_TEXT = 0;
export const ITEM_TIPO_RADIO = 1;
export const ITEM_TIPO_CHECK = 2;
export const ITEM_TIPO_FOTO = 3;

export const ITEM_EXIBIR_SEMPRE = 0;
export const ITEM_EXIBIR_INICIO = 1;
export const ITEM_EXIBIR_FIM = 2;
// reservado item menor que 5 para motorisa
export const ITEM_EXIBIR_RECEBIMENTO = 5;
export const ITEM_EXIBIR_CARREGAMENTO = 6;
export const ITEM_EXIBIR_RECEBIMENTO_CARREGAMENTO = 7;
export const ITEM_EXIBIR_COLETA_DE_RESIDUOS = 8;

export const itemTipoOptions = [
  { label: 'Texto', value: ITEM_TIPO_TEXT },
  { label: 'Escolha', value: ITEM_TIPO_RADIO },
  { label: 'Multipla Escolha', value: ITEM_TIPO_CHECK },
  { label: 'Foto', value: ITEM_TIPO_FOTO },
];

export const itemExibirOptions = [
  { label: 'Início e Fim', value: ITEM_EXIBIR_SEMPRE },
  { label: 'Início', value: ITEM_EXIBIR_INICIO },
  { label: 'Fim', value: ITEM_EXIBIR_FIM },
  { label: 'Recebimento e Carregamento', value: ITEM_EXIBIR_RECEBIMENTO_CARREGAMENTO },
  { label: 'Recebimento', value: ITEM_EXIBIR_RECEBIMENTO },
  { label: 'Carregamento', value: ITEM_EXIBIR_CARREGAMENTO },
  { label: 'Coleta de Resíduos', value: ITEM_EXIBIR_COLETA_DE_RESIDUOS },
];

function getLabelFromOptions(opts, val) {
  const found = opts.find(({ value }) => value === val)
  return found ? found.label : '--';
}

export const getItemTipoLabel = val => getLabelFromOptions(itemTipoOptions, val);

export const PEDIDO_STATUS_RECEBIDO = 0;
export const PEDIDO_STATUS_CONFERIDO = 1;
export const PEDIDO_STATUS_BOX = 2;
export const PEDIDO_STATUS_PENDENTE = 3;
export const PEDIDO_STATUS_APRESENTADO = 4;
export const PEDIDO_STATUS_DEVOLVIDO = 5;
export const PEDIDO_STATUS_DESCARREGANDO = 6;
export const PEDIDO_STATUS_ENTREGUE = 7;
// export const PEDIDO_STATUS_TRANSFERIDA = 8;
export const PEDIDO_STATUS_CANCELADO = 9;
export const PEDIDO_STATUS_CANCELADO_CONLUIDA = 10;

export const pedidoStatusOptions = [
  { label: 'Recebida', value: PEDIDO_STATUS_RECEBIDO },
  { label: 'Conferida', value: PEDIDO_STATUS_CONFERIDO },
  { label: 'Box', value: PEDIDO_STATUS_BOX },
  { label: 'Caminhão', value: PEDIDO_STATUS_PENDENTE },
  { label: 'Apresentada', value: PEDIDO_STATUS_APRESENTADO },
  { label: 'Devolvida', value: PEDIDO_STATUS_DEVOLVIDO },
  { label: 'Descarregando', value: PEDIDO_STATUS_DESCARREGANDO },
  { label: 'Entregue', value: PEDIDO_STATUS_ENTREGUE },
  // { label: 'Transferida', value: PEDIDO_STATUS_TRANSFERIDA },
  { label: 'Cancelada', value: PEDIDO_STATUS_CANCELADO },
  { label: 'Cancelada Concluída', value: PEDIDO_STATUS_CANCELADO_CONLUIDA },
]

export const getPedidoStatusLabel = val => getLabelFromOptions(pedidoStatusOptions, val);

export const PEDIDO_STATUS_RECEBIDO_COLOR = 'bg-blue-grey text-white';
export const PEDIDO_STATUS_CONFERIDO_COLOR = 'bg-pink text-white';
export const PEDIDO_STATUS_BOX_COLOR = 'bg-teal text-white';
export const PEDIDO_STATUS_PENDENTE_COLOR = 'bg-dark text-white';
export const PEDIDO_STATUS_APRESENTADO_COLOR = 'bg-blue-7 text-white';
export const PEDIDO_STATUS_DEVOLVIDO_COLOR = 'bg-red-9 text-white';
export const PEDIDO_STATUS_DESCARREGANDO_COLOR = 'bg-yellow-7 text-dark';
export const PEDIDO_STATUS_ENTREGUE_COLOR = 'bg-green-7 text-white';
// export const PEDIDO_STATUS_TRANSFERIDA_COLOR = 'bg-dark text-white';
export const PEDIDO_STATUS_CANCELADO_COLOR = 'bg-brown text-white';
export const PEDIDO_STATUS_CANCELADO_CONLUIDA_COLOR = 'bg-brown text-white';

export const pedidoStatusColor = [
  { label: PEDIDO_STATUS_RECEBIDO_COLOR, value: PEDIDO_STATUS_RECEBIDO },
  { label: PEDIDO_STATUS_CONFERIDO_COLOR, value: PEDIDO_STATUS_CONFERIDO },
  { label: PEDIDO_STATUS_BOX_COLOR, value: PEDIDO_STATUS_BOX },
  { label: PEDIDO_STATUS_PENDENTE_COLOR, value: PEDIDO_STATUS_PENDENTE },
  { label: PEDIDO_STATUS_APRESENTADO_COLOR, value: PEDIDO_STATUS_APRESENTADO },
  { label: PEDIDO_STATUS_DEVOLVIDO_COLOR, value: PEDIDO_STATUS_DEVOLVIDO },
  { label: PEDIDO_STATUS_DESCARREGANDO_COLOR, value: PEDIDO_STATUS_DESCARREGANDO },
  { label: PEDIDO_STATUS_ENTREGUE_COLOR, value: PEDIDO_STATUS_ENTREGUE },
  // { label: PEDIDO_STATUS_TRANSFERIDA_COLOR, value: PEDIDO_STATUS_TRANSFERIDA },
  { label: PEDIDO_STATUS_CANCELADO_COLOR, value: PEDIDO_STATUS_CANCELADO },
  { label: PEDIDO_STATUS_CANCELADO_CONLUIDA_COLOR, value: PEDIDO_STATUS_CANCELADO_CONLUIDA },
]

export const getPedidoStatusColor = val => getLabelFromOptions(pedidoStatusColor, val);

export const CARGA_STATUS_PENDENTE = 0;
export const CARGA_STATUS_EM_ANDAMENTO = 1;
export const CARGA_STATUS_CONCLUIDA = 2;
export const CARGA_STATUS_CANCELADA = 3;

export const cargaStatusOptions = [
  { label: 'Pendente', value: CARGA_STATUS_PENDENTE },
  { label: 'Em Andamento', value: CARGA_STATUS_EM_ANDAMENTO },
  { label: 'Concluída', value: CARGA_STATUS_CONCLUIDA },
  { label: 'Cancelada', value: CARGA_STATUS_CANCELADA },
]

export const getCargaStatusLabel = val => getLabelFromOptions(cargaStatusOptions, val);

export const CARGA_STATUS_PENDENTE_COLOR = 'bg-dark text-white';
export const CARGA_STATUS_EM_ANDAMENTO_COLOR = 'bg-yellow-7 text-dark';
export const CARGA_STATUS_CONCLUIDA_COLOR = 'bg-green-7 text-white';
export const CARGA_STATUS_CANCELADA_COLOR = 'bg-red-9 text-white';

export const cargaStatusColor = [
  { label: CARGA_STATUS_PENDENTE_COLOR, value: CARGA_STATUS_PENDENTE },
  { label: CARGA_STATUS_EM_ANDAMENTO_COLOR, value: CARGA_STATUS_EM_ANDAMENTO },
  { label: CARGA_STATUS_CONCLUIDA_COLOR, value: CARGA_STATUS_CONCLUIDA },
  { label: CARGA_STATUS_CANCELADA_COLOR, value: CARGA_STATUS_CANCELADA }
]

export const getCargaStatusColor = val => getLabelFromOptions(cargaStatusColor, val);
